module.exports = __webpack_public_path__ + "img/icon-coupon-blue.97b27a82.svg";